<template>
	<div
		class="card-category"
		:style="`background-color:${globalColors.border}`"
		v-loading="isLoading"
	>
		<div
			class="card-name"
			:style="`background-color:${globalColors.primary}`"
		>
			<img :src="category.mobileImage" alt=""> {{ category.title }}
		</div>
		<div class="card-products">
			<template v-for="product in products">
				<product-card
					:key="product.id"
					:product="product"
				></product-card>
			</template>
			<div class="card-btn">
				<div
					class="btn-link"
					@click="categoryRoute"
				>Ver más</div>
			</div>
		</div>
	</div>
</template>

<script>
	function categoryRoute() {
		const { slug, id } = this.category;
		return this.$router.push({ name: 'categories', params: { slug: slug || id, categoryId: id } });
	}

	export default {
		name: 'products-by-category',
		components: {
			productCard: () => import('@/components/product-card'),
		},
		methods: {
			categoryRoute,
		},
		props: {
			category: {
				default: () => {},
				type: Object,
			},
			isLoading: {
				default: false,
				type: Boolean,
			},
			products: {
				default: () => [],
				type: Array,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.card {
		&-category {
			padding-bottom: 3.9rem;

			@media (min-width: 768px) {
				margin-top: 6.5rem;
				padding: 0px 10rem 3.9rem;
			}
		}

		&-name {
			color: color(white);
			font-family: font(avenir);
			font-size: size(maxmedium);
			height: 3.4rem;
			line-height: 4rem;
			text-align: center;
			text-transform: uppercase;

			img {
				height: 1.9rem;
				margin-right: 0.5rem;
				vertical-align: sub;

				@media (min-width: 768px) {
					height: 2.7rem;
					vertical-align: text-bottom;
				}
			}

			@media (min-width: 768px) {
				font-size: size(mslarge);
				height: 5.5rem;
				line-height: 6rem;
				margin: 0px auto;
				max-width: fit-content;
				min-width: 27.1rem;
				padding: 0px 3.1rem;
				position: relative;
				top: -3.3rem;
				width: auto;
			}
		}

		&-products {
			margin-top: 3.2rem;
			padding: 0px 3.2rem;
			text-align: center;

			@media (min-width: 768px) {
				display: flex;
				flex-wrap: wrap;
				justify-content: center;
				padding: 0px;
			}
		}
	}

	.btn-link {
		cursor: pointer;
		font-family: font(avenirDemi);
		font-size: size(small);
	}

	.card-btn {
		flex: 100%;
	}
</style>


// WEBPACK FOOTER //
// products-by-category.vue?0550cd79